
<div :id="content.idHTML" :class="jel_getClassObject(content)">
  <div
    v-if="isSpinnerVisible"
    id="spinner"
    class="spinner-fullscreen d-flex flex-column justify-content-center align-items-center text-center"
  >
    <div
      class="spinner-card d-flex flex-column align-items-center justify-content-center text-center px-4 py-4"
    >
      <div
        class="spinner-card-text graphik_semibold mb-3"
        v-html="spinnerLongWait ? $t('messageComponent.spinnerAchalandage') : $t('chargement')"
      ></div>
      <b-spinner :label="$t('chargement')"></b-spinner>
    </div>
  </div>

  <Titre :content="contentTitreDepot"></Titre>

  <MessageMel
    v-show="contentMessageMel.message"
    :content="contentMessageMel"
    class="mt-n1 mt-md-0 mb-1 ml-md-0"
  ></MessageMel>

  <!-- ******* -->
  <!-- ACCUEIL -->
  <!-- ******* -->
  <div v-show="!methodePaiement">
    <div class="row">
      <div class="col ml-0">
        <div v-if="contentTxtHaut" class="mt-2 mb-1" v-html="contentTxtHaut"></div>
        <b-form-group class="ml-0 mb-0">
          <!-- tag="div" nécessaire pour accessibilité, éviter div dans un span -->
          <span
            class="texte texte-padding mt-0 graphik_regular"
            label-for="methodePaiement"
            v-html="content.libModeDePaiement"
          >
          </span>
          <div class="mt-1" plain name="methodePaiement">
            <div
              :disabled="isCreditCardDisabled"
              class="customRadio radio-depot encadrer"
              @click.prevent="
                !isCreditCardDisabled && changeMethodePaiement(CONSTANT.methodePaiement.card)
              "
            >
              <div class="d-flex">
                <div class="texte-radio-btn-depot d-inline-block w-65">
                  <div class="graphik_semibold my-0" v-html="content.libCarteCredit"></div>
                  <span
                    v-if="content.libCarteCredit2"
                    class="note graphik_regular"
                    v-html="content.libCarteCredit2"
                  ></span>
                </div>
                <div class="image-container d-inline-block w-35">
                  <svg-icon
                    aria-label="Visa"
                    class="svg-icon-visa mt-0"
                    :icon-name="isCreditCardDisabled ? 'card-visa-gris' : 'card-visa'"
                  ></svg-icon>
                  <svg-icon
                    aria-label="Mastercard"
                    class="svg-icon-mc mt-0"
                    :icon-name="isCreditCardDisabled ? 'card-mastercard-gris' : 'card-mastercard'"
                  ></svg-icon>
                  <svg-icon
                    aria-label="American Express"
                    class="svg-icon-amex mt-0"
                    :icon-name="isCreditCardDisabled ? 'card-amex-gris' : 'card-amex'"
                  ></svg-icon>
                </div>
              </div>
              <Separateur class="mx-0 my-1"></Separateur>
              <div class="d-flex">
                <div class="texte-radio-btn-depot d-inline-block w-65">
                  <div class="graphik_semibold my-0" v-html="content.libCarteDebit"></div>
                  <span
                    v-if="content.libCarteDebit2"
                    class="note graphik_regular"
                    v-html="content.libCarteDebit2"
                  ></span>
                </div>
                <div class="image-container d-inline-block w-35">
                  <svg-icon
                    aria-label="Visa"
                    class="svg-icon-visa mt-0"
                    :icon-name="isCreditCardDisabled ? 'card-visa-gris' : 'card-visa'"
                  ></svg-icon>
                  <svg-icon
                    aria-label="Mastercard"
                    class="svg-icon-mc mt-0"
                    :icon-name="isCreditCardDisabled ? 'card-mastercard-gris' : 'card-mastercard'"
                  ></svg-icon>
                </div>
              </div>
              <ErreurValidation
                v-if="!isErreurServeur && messageErreurCreditCard"
                id="choix-depot-invalid-feedback"
                classesCSS="mx-0"
                :message="messageErreurCreditCard"
              ></ErreurValidation>
            </div>
            <template>
              <v-popover
                v-show="isTooltipVirementInteracVisible"
                trigger="manual"
                :open="isTooltipVirementInteracVisible"
                offset="25px"
                :auto-hide="false"
                placement="top-start"
                container="form"
                class="pl-1"
                shadow-sm
              >
                <template slot="popover">
                  <div class="d-flex flex-row justify-content-between">
                    <button
                      class="close py-0 pl-1 pr-0 mb-2"
                      @click.prevent="cacherTooltip('VirementInterac')"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <Paragraphe
                    :content="{
                      richText: content.txtBulleVirementInterac,
                    }"
                    class="texte-tooltip ml-2 mr-2 mt-2"
                  ></Paragraphe>
                  <Hyperlien
                    v-if="contentLienAideBulleVirementInterac"
                    class="lien-aide ml-2 mr-2 mb-2"
                    :content="contentLienAideBulleVirementInterac"
                  ></Hyperlien>
                </template>
              </v-popover>
            </template>

            <!-- Virement Interac -->

            <div
              :disabled="iseTransferLimiteReached"
              class="customRadio encadrer radio-depot"
              @click.prevent="
                !iseTransferLimiteReached && changeMethodePaiement(CONSTANT.methodePaiement.et)
              "
            >
              <div class="d-flex">
                <div class="texte-radio-btn-depot d-inline-block w-65">
                  <div class="graphik_semibold" v-html="content.libVirementInterac"></div>
                  <span
                    v-if="content.libVirementInterac2"
                    class="note graphik_regular"
                    v-html="content.libVirementInterac2"
                  ></span>
                </div>
                <div class="image-container d-inline-block w-35">
                  <svg-icon
                    aria-label="Interac"
                    class="svg-icon-interac mr-0 mt-0"
                    :icon-name="iseTransferLimiteReached ? 'logo-Interac-gris' : 'logo-Interac'"
                  ></svg-icon>
                </div>
              </div>
            </div>

            <!-- Apple Pay -->
            <template>
              <v-popover
                v-show="isTooltipApplePayVisible"
                v-if="jel_applePayActif()"
                trigger="manual"
                :open="isTooltipApplePayVisible"
                offset="25px"
                :auto-hide="false"
                placement="top-start"
                container="form"
                class="pl-1"
                shadow-sm
              >
                <template slot="popover">
                  <div class="d-flex flex-row justify-content-between">
                    <button
                      class="close py-0 pl-1 pr-0 mb-2"
                      @click.prevent="cacherTooltip('ApplePay')"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <Paragraphe
                    :content="{
                      richText: content.txtBulleApplePay,
                    }"
                    class="texte-tooltip ml-2 mr-2 mt-2"
                  ></Paragraphe>
                  <Hyperlien
                    v-if="contentLienAideBulleApplePay"
                    class="lien-aide ml-2 mr-2 mb-2"
                    :content="contentLienAideBulleApplePay"
                  ></Hyperlien>
                </template>
              </v-popover>
            </template>

            <div
              v-if="jel_applePayActif()"
              :disabled="isApplePayDisabled"
              class="customRadio encadrer radio-depot"
              @click.prevent="
                !isApplePayDisabled && changeMethodePaiement(CONSTANT.methodePaiement.ap)
              "
            >
              <div class="d-flex">
                <div class="texte-radio-btn-depot d-inline-block w-65">
                  <div class="graphik_semibold" v-html="content.libApplePay"></div>
                  <span
                    v-if="content.libApplePay2"
                    class="note graphik_regular"
                    v-html="content.libApplePay2"
                  ></span>
                </div>
                <div class="image-container d-inline-block w-35">
                  <svg-icon
                    aria-label="Applepay"
                    class="svg-icon-applepay mr-0 mt-0"
                    :icon-name="isApplePayDisabled ? 'logo-applepay-gris' : 'logo-applepay'"
                  ></svg-icon>
                </div>
              </div>
              <ErreurValidation
                v-if="!isErreurServeur && messageErreurApplePay"
                id="choix-depot-invalid-feedback"
                classesCSS="mx-0"
                :message="messageErreurApplePay"
              ></ErreurValidation>
            </div>

            <!-- Google Pay -->
            <template v-if="jel_googlePayActif()">
              <v-popover
                v-show="isTooltipGooglePayVisible"
                trigger="manual"
                :open="isTooltipGooglePayVisible"
                offset="25px"
                :auto-hide="false"
                placement="top-start"
                container="form"
                class="pl-1"
                shadow-sm
              >
                <template slot="popover">
                  <div class="d-flex flex-row justify-content-between">
                    <button
                      class="close py-0 pl-1 pr-0 mb-2"
                      @click.prevent="cacherTooltip('GooglePay')"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <Paragraphe
                    :content="{
                      richText: content.txtBulleGooglePay,
                    }"
                    class="texte-tooltip ml-2 mr-2 mt-2"
                  ></Paragraphe>
                  <Hyperlien
                    v-if="contentLienAideBulleGooglePay"
                    class="lien-aide ml-2 mr-2 mb-2"
                    :content="contentLienAideBulleGooglePay"
                  ></Hyperlien>
                </template>
              </v-popover>
            </template>

            <div
              v-if="jel_googlePayActif()"
              :disabled="isGooglePayDisabled"
              class="customRadio encadrer radio-depot"
              @click.prevent="
                !isGooglePayDisabled && changeMethodePaiement(CONSTANT.methodePaiement.gp)
              "
            >
              <div class="d-flex">
                <div class="texte-radio-btn-depot d-inline-block w-65">
                  <div class="graphik_semibold" v-html="content.libGooglePay"></div>
                  <span
                    v-if="content.libGooglePay2"
                    class="note graphik_regular"
                    v-html="content.libGooglePay2"
                  ></span>
                </div>
                <div class="image-container d-inline-block w-35">
                  <svg-icon
                    aria-label="Googlepay"
                    class="svg-icon-googlepay mr-0 mt-0"
                    :icon-name="isGooglePayDisabled ? 'logo-googlepay-gris' : 'logo-googlepay'"
                  ></svg-icon>
                </div>
              </div>
              <ErreurValidation
                v-if="!isErreurServeur && messageErreurGooglePay"
                id="choix-depot-invalid-feedback"
                classesCSS="mx-0"
                :message="messageErreurGooglePay"
              ></ErreurValidation>
            </div>

            <!-- ARGENT WEB -->
            <div
              v-if="jel_argentWebActif()"
              :disabled="isArgentWebDisabled"
              class="customRadio encadrer radio-depot"
              @click.prevent="
                !isArgentWebDisabled && changeMethodePaiement(CONSTANT.methodePaiement.argentWeb)
              "
            >
              <div class="d-flex">
                <div class="texte-radio-btn-depot d-inline-block w-65">
                  <div class="graphik_semibold">
                    <Hyperlien
                      class="rem-style"
                      :disabled="isArgentWebDisabled"
                      :content="contentLienCouponArgentWeb"
                    ></Hyperlien>
                  </div>
                </div>
                <div v-if="inAppMobile" class="image-container d-inline-block w-35">
                  <svg-icon
                    aria-label="Argentweb"
                    class="svg-icon-argentweb mr-0 mt-0"
                    :icon-name="isArgentWebDisabled ? 'qr-code-gris' : 'qr-code'"
                  ></svg-icon>
                </div>

                <div v-else class="image-container d-inline-block w-35">
                  <svg-icon
                    aria-label="Argentweb"
                    class="svg-icon-argentweb mr-0 mt-0"
                    :icon-name="isArgentWebDisabled ? 'im-argent-web-gris' : 'im-argent-web'"
                  ></svg-icon>
                </div>
              </div>
              <ErreurValidation
                v-if="!isErreurServeur && messageErreurArgentWeb"
                id="choix-depot-invalid-feedback"
                classesCSS="mx-0"
                :message="messageErreurArgentWeb"
                :variables="variablesRemplacementArgentWeb"
              ></ErreurValidation>
            </div>

            <!-- PAIEMENT FACTURES -->
            <div
              v-if="jel_paiementFacturesActif()"
              :disabled="isPaiementFacturesDisabled"
              class="customRadio encadrer radio-depot"
              @click.prevent="
                !isPaiementFacturesDisabled &&
                  changeMethodePaiement(CONSTANT.methodePaiement.paiementFactures)
              "
            >
              <div class="d-flex">
                <div class="texte-radio-btn-depot d-inline-block w-90">
                  <div class="graphik_semibold">
                    <Hyperlien
                      class="rem-style"
                      :disabled="isErreurServeur"
                      :content="contentLienPaiementFactures"
                    ></Hyperlien>
                  </div>
                </div>
                <div class="image-container d-inline-block w-10">
                  <svg-icon
                    aria-label="Paiementfactures"
                    class="svg-icon-paiementfactures mr-0 mt-0"
                    :icon-name="
                      isPaiementFacturesDisabled ? 'icone-facture' : 'icone-facture-gris'
                    "
                  ></svg-icon>
                </div>
              </div>
            </div>
          </div>
        </b-form-group>

        <div v-if="contentTxtBas" class="mt-3 mb-0" v-html="contentTxtBas"></div>
      </div>
    </div>
  </div>

  <!-- ****************** -->
  <!-- Carte Crédit/Débit -->
  <!-- Virement INTERAC   -->
  <!-- INTERAC en ligne   -->
  <!-- ****************** -->
  <ValidationObserver
    v-show="
      [
        CONSTANT.methodePaiement.card.paymentMethod,
        CONSTANT.methodePaiement.et.paymentMethod,
        CONSTANT.methodePaiement.ap.paymentMethod,
        CONSTANT.methodePaiement.gp.paymentMethod,
      ].includes(methodePaiement)
    "
    ref="observer"
    v-slot="{ handleSubmit, invalid }"
    tag="div"
  >
    <!-- Carte Crédit/Débit -->
    <div
      v-if="methodePaiement === CONSTANT.methodePaiement.card.paymentMethod"
      class="big-image-container text-md-left text-center"
    >
      <svg-icon aria-label="Visa" class="svg-big-icon-visa mt-0" icon-name="card-visa"></svg-icon>
      <svg-icon
        aria-label="Mastercard"
        class="svg-big-icon-mc mt-0 ml-2"
        icon-name="card-mastercard"
      ></svg-icon>
      <svg-icon
        aria-label="American Express"
        class="svg-big-icon-amex mt-0 ml-2"
        icon-name="card-amex"
      ></svg-icon>
      <Hyperlien
        v-if="contentLienAideCredit"
        class="lien-aide ml-0 mt-0 mr-0"
        :content="contentLienAideCredit"
      ></Hyperlien>
    </div>

    <!-- Virement INTERAC -->
    <div
      v-else-if="methodePaiement === CONSTANT.methodePaiement.et.paymentMethod"
      class="big-image-container text-md-left text-center"
    >
      <svg-icon
        aria-label="Interac"
        class="svg-icon-big mr-0 mt-0"
        icon-name="logo-Interac"
      ></svg-icon>
    </div>

    <!-- Apple Pay -->
    <div
      v-else-if="methodePaiement === CONSTANT.methodePaiement.ap.paymentMethod"
      class="big-image-container text-md-left text-center"
    >
      <svg-icon
        aria-label="ApplePay"
        class="svg-icon-applepay-big mr-0 mt-2"
        icon-name="logo-applepay"
      ></svg-icon>
      <Hyperlien
        v-if="contentLienAideApplePay"
        class="lien-aide mx-0 mt-1"
        :content="contentLienAideApplePay"
      ></Hyperlien>
    </div>

    <!-- Google Pay -->
    <div
      v-else-if="methodePaiement === CONSTANT.methodePaiement.gp.paymentMethod"
      class="big-image-container text-md-left text-center"
    >
      <svg-icon
        aria-label="GooglePay"
        class="svg-icon-googlepay-big mr-0 mt-2"
        icon-name="logo-googlepay"
      ></svg-icon>
      <Hyperlien
        v-if="contentLienAideGooglePay"
        class="lien-aide mx-0 mt-1"
        :content="contentLienAideGooglePay"
      ></Hyperlien>
    </div>

    <!-- INTERAC en ligne -->
    <div v-else class="big-image-container text-md-left text-center">
      <svg-icon
        aria-label="Interac"
        class="svg-icon-big mr-1 mt-0"
        icon-name="logo-Interac"
      ></svg-icon>
      <span v-html="$t('messageComponent.avec')"></span>
      <svg-icon
        aria-label="TD Canada Trust"
        class="svg-icon-small ml-1 mr-0 mt-0"
        icon-name="TD"
      ></svg-icon>
    </div>

    <b-form class="mt-5" @submit.stop.prevent="handleSubmit(onSubmit)">
      <div v-if="contentTxtHaut" class="mt-0 mb-0" v-html="contentTxtHaut"></div>
      <ValidationProvider
        v-slot="{ errors }"
        name="amount"
        :rules="`${
          methodePaiement === CONSTANT.methodePaiement.ap.paymentMethod ? 'required|' : ''
        }is_depot_valid:${depotMinimum},${depotMaximum}`"
      >
        <b-form-group class="ml-2">
          <div class="row">
            <div v-if="$i18n.locale == 'en'">
              <legend class="texte texte-padding mt-2 mr-1">
                <span v-html="content.libMontantDepot"></span>
                <span
                  class="texte graphik_regular"
                  v-html="'($20&nbsp;' + content.libMinimum + ')'"
                ></span>
              </legend>
            </div>
            <div v-else>
              <legend class="texte texte-padding mt-2 mr-1">
                <span v-html="content.libMontantDepot"></span>
                <span
                  class="texte graphik_regular"
                  v-html="'(' + content.libMinimum + '&nbsp;20&nbsp;$)'"
                ></span>
              </legend>
            </div>
          </div>
          <div class="row col-8 col-md-5 px-0">
            <b-form-input
              id="montant"
              ref="inputMontant"
              v-model="montant"
              :aria-label="content.libMontantDepot"
              name="montant"
              type="text"
              inputmode="decimal"
              maxLength="7"
              autocomplete="off"
              class="grandTexte graphik_regular text-left px-1"
              :class="{
                'is-invalid': errors.length > 0, // Attention si on ne met pas ceci les erreurs n'aparaissent pas pour v-money...
              }"
              @keypress="onlyNumbers($event)"
              @blur.native="forceValidate()"
            ></b-form-input>
          </div>
          <div class="row">
            <!-- On n'affiche pas le message d'erreur MSG00-03("Le champs est obligatoire") sur la validation de l'input -->
            <ErreurValidation
              v-if="errors[0]"
              id="montantDepot-invalid-feedback"
              :message="errors[0]"
              :variables="variablesRemplacementMinMax"
            ></ErreurValidation>
          </div>
        </b-form-group>

        <div
          v-if="methodePaiement === CONSTANT.methodePaiement.et.paymentMethod"
          class="encadrer cursor-default"
          :disabled="isETransferDisabled"
        >
          <div
            class="grandTexte font-titre pt-1"
            v-html="content.txtTitreVirementInteracET"
          ></div>
          <ErreurValidation
            v-if="messageErreurETransfer"
            id="choix-depot-invalid-feedback"
            classesCSS="mx-0"
            :message="messageErreurETransfer"
          ></ErreurValidation>
          <div v-else>
            <div v-if="contentTxtBas" class="mt-1 mb-3" v-html="contentTxtBas"></div>
            <div class="d-flex flex-column align-items-center align-items-md-start">
              <b-button
                v-if="!isApplePayBtnActive()"
                type="submit"
                variant="primaire"
                class="w-auto px-4 py-1 mx-0 mb-2"
                :disabled="invalid || isSubmitted || !montant || isETransferDisabled"
                :class="{ valid: !invalid }"
              >
                <div class="d-inline-flex w-auto">
                  <div v-if="isSubmitted && !isPaiementES" class="mr-1">
                    <b-spinner small :label="$t('chargement')"></b-spinner>
                  </div>
                  <span
                    class="text-white"
                    v-html="
                      methodePaiement === CONSTANT.methodePaiement.et.paymentMethod &&
                      !isSafariWeb
                        ? content.libOuvrirVirementInterac
                        : content.libBoutonContinuer
                    "
                  ></span>
                  <svg-icon
                    v-if="
                      methodePaiement === CONSTANT.methodePaiement.et.paymentMethod &&
                      !isSafariWeb
                    "
                    aria-label="share"
                    class="svg-icon-share ml-4px mr-0"
                    icon-name="ic-share"
                  ></svg-icon>
                </div>
              </b-button>
            </div>
          </div>
        </div>
        <div
          v-if="methodePaiement === CONSTANT.methodePaiement.et.paymentMethod"
          class="encadrer cursor-default"
          :class="isETransferESDisabled ? 'color-disabled' : ''"
        >
          <div
            class="grandTexte font-titre pt-1"
            :class="isETransferESDisabled ? 'color-disabled' : ''"
            v-html="content.txtTitreVirementInteracES"
          ></div>
          <div>
            <div
              v-if="content.txtVirementInteracES"
              class="mt-1 mb-3"
              :class="isETransferESDisabled ? 'color-disabled' : ''"
              v-html="content.txtVirementInteracES"
            ></div>
            <ErreurValidation
              v-if="messageErreurETransferES"
              id="choix-depot-invalid-feedback"
              classesCSS="mx-0"
              :message="messageErreurETransferES"
            ></ErreurValidation>
            <div
              v-if="esStatus === 'NO' && esPayment.paymentRef"
              class="lienPrimaire cursor-pointer"
              @click="changeMethodePaiement(CONSTANT.methodePaiement.es)"
            >
              {{ content.libInfoVirementInteracDesjardins }}
            </div>
            <div
              v-else-if="esStatus === 'YES' && !isETransferESDisabled"
              class="d-flex flex-column align-items-center align-items-md-start w-fit-content conteneur-btn-desjardins"
            >
              <b-button
                type="submit"
                variant="secondaire"
                class="w-auto px-4 py-1 mx-0 mb-2"
                :disabled="invalid || isSubmitted || !montant || isETransferESDisabled"
                :class="{ valid: !invalid }"
                @click="initierPaiementES()"
              >
                <div class="d-inline-flex w-auto">
                  <div v-if="isSubmitted && isPaiementES" class="mr-1">
                    <b-spinner small :label="$t('chargement')"></b-spinner>
                  </div>
                  <span v-html="content.libOuvrirVirementInteracDesjardins"></span>
                </div>
              </b-button>
            </div>
          </div>
        </div>

        <div v-else-if="methodePaiement === CONSTANT.methodePaiement.gp.paymentMethod">
          <div class="d-flex flex-column align-items-center align-items-md-start">
            <iframe
              v-show="isGooglePayBtnActive()"
              id="iframePaysafeGP"
              :key="'gp-' + methodePaiement"
              title="iFrame Paysafe GP"
              :src="iframeSrcGP"
              width="100%"
              height="80px"
              frameborder="0"
              allowfullscreen
              allow="payment"
            ></iframe>
          </div>
        </div>

        <div v-else>
          <div
            v-if="contentTxtBas && !isSafariWeb"
            class="mt-1 mb-3"
            v-html="contentTxtBas"
          ></div>
          <div class="d-flex flex-column align-items-center align-items-md-start">
            <iframe
              v-show="isApplePayBtnActive()"
              id="iframePaysafeJS"
              :key="'ap-' + methodePaiement"
              title="iFrame Paysafe JS"
              :src="iframeSrcJS"
              width="100%"
              height="80px"
              frameborder="0"
              allowfullscreen
              allow="payment"
            ></iframe>
            <b-button
              v-if="!isApplePayBtnActive()"
              type="submit"
              variant="primaire"
              class="w-auto px-4 py-1 mx-0 mb-2"
              :disabled="invalid || isSubmitted || !montant"
              :class="{ valid: !invalid }"
            >
              <div class="d-inline-flex w-auto">
                <div v-if="isSubmitted" class="mr-1">
                  <b-spinner small :label="$t('chargement')"></b-spinner>
                </div>
                <span
                  class="text-white"
                  v-html="
                    methodePaiement === CONSTANT.methodePaiement.et.paymentMethod && !isSafariWeb
                      ? content.libOuvrirVirementInterac
                      : content.libBoutonContinuer
                  "
                ></span>
                <svg-icon
                  v-if="
                    methodePaiement === CONSTANT.methodePaiement.et.paymentMethod && !isSafariWeb
                  "
                  aria-label="share"
                  class="svg-icon-share ml-4px mr-0"
                  icon-name="ic-share"
                ></svg-icon>
              </div>
            </b-button>
          </div>
        </div>
      </ValidationProvider>
    </b-form>
  </ValidationObserver>

  <!-- ********** -->
  <!-- Argent Web -->
  <!-- ********** -->
  <div v-show="methodePaiement === CONSTANT.methodePaiement.argentWeb.paymentMethod">
    <div v-if="content.txtArgentWebHaut" v-html="content.txtArgentWebHaut"></div>

    <ValidationObserver ref="observer" v-slot="{ handleSubmit, invalid }" tag="div">
      <b-form @submit.stop.prevent="handleSubmit(onSubmit)">
        <ValidationProvider
          ref="validateur"
          v-slot="validationContext"
          :name="content.libCodeArgentWeb"
          :rules="`required|is_code_argent_web_valid`"
          tag="div"
        >
          <b-form-group
            :label="content.libArgentWebCode"
            label-for="codeArgentWeb"
            class="col-md-10 ml-n2"
          >
            <b-form-input
              id="codeArgentWeb"
              ref="couponWeb"
              v-model="codeArgentWeb"
              trim
              type="text"
              autocomplete="off"
              :class="{
                'is-invalid':
                  validationContext.errors.length > 0 &&
                  validationContext.errors[0] !== 'MSG00-03' &&
                  validationContext.errors[0] !== 'MSG00-04',
              }"
              @blur.native="forceValidate()"
            ></b-form-input>
            <ErreurValidation
              v-if="validationContext.errors[0] && validationContext.errors[0] !== 'MSG00-04'"
              id="codeArgentWeb-invalid-feedback"
              :message="validationContext.errors[0]"
              :variables="variablesARemplacer"
            ></ErreurValidation>
          </b-form-group>
        </ValidationProvider>
        <div class="text-center text-md-left py-1">
          <b-button
            type="submit"
            variant="primaire"
            class="btn w-auto hauteur px-4 mb-2"
            :disabled="invalid || isSubmitted"
            :class="{ valid: !invalid }"
          >
            <div class="d-inline-flex w-auto">
              <div v-if="isSubmitted" class="mr-1">
                <b-spinner small :label="$t('chargement')"></b-spinner>
              </div>
              <span class="text-white" v-html="content.libArgentWebBoutonDeposer"></span>
            </div>
          </b-button>
        </div>
        <!-- <span @click.capture="preventClickRetourDepot">
          <Hyperlien
            class="text-center text-sm-left mb-2 mt-n1"
            :content="contentRetourDepot"
          ></Hyperlien>
        </span> -->
      </b-form>
    </ValidationObserver>

    <span @click.prevent="changeMethodePaiement(null)">
      <Hyperlien
        class="mt-0 mb-1 align-items-center text-md-left text-center"
        :content="contentLienAutreModeDepot"
      ></Hyperlien>
    </span>

    <div v-if="content.txtArgentWebBas" v-html="content.txtArgentWebBas"></div>

    <Hyperlien
      v-if="!mixinEnvironnement_inAppMobile && contentLienAideArgentWeb"
      class="lien-aide text-left ml-0 mt-0 mr-0"
      :content="contentLienAideArgentWeb"
    ></Hyperlien>
  </div>

  <!-- ********************** -->
  <!-- INTERAC ENVOI DE FONDS -->
  <!-- ********************** -->
  <div v-show="methodePaiement === CONSTANT.methodePaiement.es.paymentMethod">
    <div v-if="isPremierPaiementES" class="row">
      <div class="col">
        <Paragraphe
          :content="{
            richText: content.txtEnvoiDeFondsExplication,
          }"
        ></Paragraphe>
        <Titre
          :content="{
            type: 'titre',
            titre: content.titreInfoVirement,
            classeCSS: 'mb-2 pt-1',
          }"
          :class="{ 'text-center': $isMobile() }"
        >
        </Titre>
        <Paragraphe
          :content="{
            richText: content.txtEnvoiDeFonds,
          }"
        ></Paragraphe>
      </div>
    </div>

    <div v-else class="row">
      <div class="col">
        <Titre
          :content="{
            type: 'titre',
            titre: content.titreInfoVirementEnCours,
            classeCSS: 'mb-2 pt-1',
          }"
          :class="{ 'text-center': $isMobile() }"
        >
        </Titre>
      </div>
    </div>

    <div class="es-info">
      <div class="row px-1">
        <div class="col-2 ml-0 py-1 px-0">
          <span v-html="$i18n.t('compte.depot.virementInteracEnvoi.libCourriel')"></span>
        </div>
        <div class="col-9 ml-0">
          <strong>{{ esPayment.lqEmail }}</strong>
        </div>
        <div class="col-1 ml-0 px-0 justify-right">
          <BoutonCopier :content="{ textToCopy: esPayment.lqEmail }"></BoutonCopier>
        </div>
      </div>
      <div class="row px-1">
        <div class="col-2 ml-0 py-1 px-0">
          <span v-html="$i18n.t('compte.depot.virementInteracEnvoi.libMessage')"></span>
        </div>
        <div class="col-9 ml-0">
          <strong>{{ esPayment.paymentRef }}</strong>
        </div>
        <div class="col-1 ml-0 px-0 justify-right">
          <BoutonCopier :content="{ textToCopy: esPayment.paymentRef }"></BoutonCopier>
        </div>
        <div class="col-2 ml-0 px-0 attention">
          <span>i</span>
        </div>
        <div
          class="col-10 ml-0 note"
          v-html="$i18n.t('compte.depot.virementInteracEnvoi.noteMessage')"
        ></div>
      </div>
      <div class="row px-1">
        <div class="col-2 ml-0 py-1 px-0">
          <span v-html="$i18n.t('compte.depot.virementInteracEnvoi.libMontant')"></span>
        </div>
        <div class="col-9 ml-0">
          <strong>{{ esPayment.montantEsFormat }}</strong>
        </div>
        <div class="col-1 ml-0 px-0 justify-right">
          <BoutonCopier :content="{ textToCopy: esPayment.mantantEsBrut }"></BoutonCopier>
        </div>
        <div class="col-2 ml-0 px-0 attention">
          <span>i</span>
        </div>
        <div
          class="col-10 ml-0 note"
          v-html="$i18n.t('compte.depot.virementInteracEnvoi.noteMontant')"
        ></div>
      </div>
    </div>
  </div>

  <!-- ***************** -->
  <!-- Paiement Factures -->
  <!-- ***************** -->
  <div v-show="methodePaiement === CONSTANT.methodePaiement.paiementFactures.paymentMethod">
    <Paragraphe :content="{ richText: content.txtPaiementFacture }"></Paragraphe>
  </div>

  <span
    v-show="
      methodePaiement &&
      methodePaiement !== CONSTANT.methodePaiement.argentWeb.paymentMethod &&
      methodePaiement !== CONSTANT.methodePaiement.es.paymentMethod
    "
    @click.prevent="changeMethodePaiement(null)"
  >
    <Hyperlien
      class="mt-0 mb-1 align-items-center align-items-md-start text-md-left text-center"
      :content="contentLienAutreModeDepot"
    ></Hyperlien>
  </span>

  <span
    v-if="!productSource"
    v-show="methodePaiement && methodePaiement === CONSTANT.methodePaiement.es.paymentMethod"
    @click.prevent="esRetourMethodeDepot()"
  >
    <Hyperlien
      class="mt-0 mb-1 align-items-center align-items-md-start text-md-left text-center"
      :content="contentLienAutreModeDepot"
    ></Hyperlien>
  </span>

  <span v-show="methodePaiement && methodePaiement === CONSTANT.methodePaiement.es.paymentMethod">
    <!-- Hyperlien lienRetourProductSource -->
    <Hyperlien
      v-if="productSource"
      class="mt-0 mb-1 align-items-center align-items-md-start text-md-left text-center"
      :content="contentLienRetourProductSourceEs"
    ></Hyperlien>
    <Hyperlien
      v-else
      class="mt-0 mb-1 align-items-center align-items-md-start text-md-left text-center"
      :content="contentEsAccueil"
    ></Hyperlien>
  </span>

  <!-- z-order="999" nécessaire pour l'affichage de l'IFrame quand on clique sur le bouton submit par la méthode showHideIframe() -->
  <div
    v-show="false"
    id="modalPaysafe"
    ref="modalPaysafe"
    class="modal"
    :class="{ 'mt-3': mixinEnvironnement_inAppMobile }"
    role="dialog"
    z-order="999"
  >
    <iframe
      id="iframePaysafe"
      title="iFrame Paysafe"
      :src="iframeSrc"
      width="100%"
      height="100%"
      frameborder="0"
      allowfullscreen
    ></iframe>
  </div>

  <!-- Fenêtre modale ET (Virement INTERAC) uniquement pour Safari Web-->
  <b-modal
    id="modaleETSafariWeb"
    body-class="py-5 px-4 compteClair"
    centered
    hide-header-close
    no-hide-backdrop
    no-close-on-backdrop
    no-close-on-esc
    hide-footer
    hide-header
  >
    <div>
      <div v-if="contentTxtBas" class="mt-1 mb-3" v-html="contentTxtBas"></div>

      <div class="d-flex flex-column align-items-center align-items-md-start">
        <b-button
          type="submit"
          variant="primaire"
          class="btn btn-primaire boutonPrimaire w-auto px-3 py-1 mx-0 mb-2"
          :href="etRedirectUrl"
          target="_blank"
          @click.stop="fermerModaleETSafariWeb()"
        >
          <div class="d-inline-flex w-auto mt-4px">
            <span class="text-white" v-html="content.libOuvrirVirementInterac"></span>
            <svg-icon
              aria-label="share"
              class="svg-icon-share ml-4px mr-0"
              icon-name="ic-share"
            ></svg-icon>
          </div>
        </b-button>
      </div>
    </div>
  </b-modal>

  <!-- Fenêtre modale ET (Virement INTERAC) -->
  <b-modal
    id="modaleET"
    body-class="py-5 px-4 compteClair"
    centered
    hide-header-close
    no-hide-backdrop
    no-close-on-backdrop
    no-close-on-esc
    hide-footer
    hide-header
  >
    <div>
      <Titre
        :content="{
          type: 'titre',
          titre: content.libModaleETTitre,
          classeCSS: 'mb-2 pt-1',
        }"
        :class="{ 'text-center': $isMobile() }"
      >
      </Titre>

      <div v-if="content.txtModaleETHaut" v-html="content.txtModaleETHaut"></div>

      <div class="d-flex flex-column align-items-center">
        <!-- Hyperlien lienRetourProductSource -->
        <Hyperlien
          v-if="productSource"
          class="mt-0 mb-0 align-items-center text-center"
          :content="contentLienRetourProductSource"
        ></Hyperlien>
        <!-- Hyperlien lienPrimaire, aussi saisir le lien pour jouer? -->
        <Hyperlien
          v-else
          class="mt-0 mb-0 align-items-center text-center"
          :content="contentLibModaleETJouerMaintenant"
        ></Hyperlien>
      </div>

      <!-- Hyperlien lienSecondaire, aussi saisir le lien pour jouer? -->
      <Hyperlien class="mt-0 mb-5 text-center" :content="contentLienVoirMonCompte"></Hyperlien>

      <div v-if="content.txtModaleETBas" v-html="content.txtModaleETBas"></div>
      <span @click.prevent="fermerModaleET()">
        <Hyperlien
          class="mt-0 mb-2 text-center"
          :content="contentLienRetournerPageDepot"
        ></Hyperlien>
      </span>
    </div>
  </b-modal>

  <!-- Astuce pour ouvrir un navigateur externe dans l'App iOS (et Android) -->
  <!-- eslint-disable-next-line vuejs-accessibility/anchor-has-content -->
  <a id="aHrefEtRedirectUrl" aria-hidden="true" :href="etRedirectUrl" class="d-none">&nbsp;</a>
</div>
